import React, { ElementType } from 'react'

import { Wrappers } from './styles/Wrapper'

interface Props {
  Icon: ElementType
  className: string
  corner?: keyof typeof Wrappers
}

export default function GameIcon({ Icon, className, corner = 'left-top' }: Props) {
  const Wrapper = Wrappers[corner]

  return (
    <Wrapper>
      <div className={className}>
        <Icon />
      </div>
    </Wrapper>
  )
}
